// features/cadastral/api/cadastral.api.js
// API client for the maps microservice (ms-maps) through the API Gateway

import { api } from '../../../api/client';

export const cadastralApi = {
  /**
   * Fetches a property's cadastral record by its 15-digit key.
   * @param {string} cadastralKey
   * @returns {Promise<{record: object, file: object}>} Raw maps-service response.
   */
  getPropertyRecord: (cadastralKey) => api.get(`/maps/predios/${encodeURIComponent(cadastralKey)}`),

  /**
   * Searches properties with optional filters (paginated GET).
   * @param {object} params
   */
  searchProperties: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return api.get(`/maps/predios${queryParams ? `?${queryParams}` : ''}`);
  },

  /**
   * Searches properties with advanced filters (POST).
   * @param {object} data
   */
  searchPropertiesAdvanced: (data) => api.post('/maps/predios/search', data),

  /**
   * Gets global cadastral registry statistics.
   */
  getStats: () => api.get('/maps/stats'),

  /**
   * Checks the maps service health.
   */
  health: () => api.get('/maps/health'),
};